import { isEqual, isEmpty } from 'lodash';
import * as ACTIONS from './actions';
import * as MUTATIONS from './mutations';
import * as api from '../../../api/auth';


function initialState() {
  return {
    isAuth: false,
    id: null,
    firstname: null,
    lastname: null,
    email: null,
    contractor: null,
    privileges: [],
  };
}

export default {
  namespaced: true,
  state: () => initialState(),

  getters: {
    /**
     * Get user name initials
     * @param state
     * @returns {string}
     */
    initials: (state) => {
      const firstname = state.firstname || '';
      const lastname = state.lastname || '';
      return `${firstname.charAt(0).toUpperCase()}${lastname.charAt(0).toUpperCase()}`;
    },

    /**
     * Get user full name
     * @param state
     * @returns {string}
     */
    fullName: (state) => `${state.firstname} ${state.lastname}`,

    /**
     * Check has user privilege
     * @param state
     * @returns {function({resource: *, code: *}): *}
     */
    hasPrivilege: (state) => ({ resource, code }) => (
      !isEmpty(state.privileges.filter((privilege) => (
        isEqual({ resource, code }, privilege))))
    ),
  },

  mutations: {
    /**
     * Set is_auth state
     * @param state
     * @param isAuth
     */
    [MUTATIONS.SET_IS_AUTH](state, isAuth) {
      state.isAuth = !!isAuth;
    },

    /**
     * Set user state from payload
     * @param state
     * @param payload
     */
    [MUTATIONS.SET_USER](state, payload) {
      Object.keys(payload).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(state, key)) state[key] = payload[key];
      });
    },

    [MUTATIONS.CLEAR](state) {
      const init = initialState();
      Object.keys(init).forEach((key) => {
        state[key] = init[key];
      });
    },

  },

  actions: {
    /**
     * Login on server by username/password
     * @param context
     * @param username
     * @param password
     * @returns {Promise<void>}
     */
    async [ACTIONS.LOGIN](context, { username, password }) {
      await api.authentication(username, password);
    },

    /**
     * Logout from system
     * @returns {Promise<void>}
     */
    async [ACTIONS.LOGOUT]() {
      await api.logout();
      localStorage.removeItem('newsAndUpdates');
    },

    /**
     * Fetch user from server
     * @param context
     * @returns {Promise<*>}
     */
    async [ACTIONS.USER](context) {
      const { data } = await api.user();
      context.commit(MUTATIONS.SET_IS_AUTH, true);
      context.commit(MUTATIONS.SET_USER, data);
      return data;
    },

    /**
     * Request for restore password
     * @param context
     * @param email
     * @returns {Promise<any>}
     */
    async [ACTIONS.RESTORE_PASSWORD](context, { email }) {
      const response = await api.restorePassword(email);
      return response.data;
    },

    /**
     * Decrypt link for user operations
     * @param context
     * @param enc
     * @returns {Promise<any>}
     */
    async [ACTIONS.RESTORE_LINK_DECRYPT](context, { enc }) {
      const response = await api.decryptRestoreLink(enc);
      return response.data;
    },

    /**
     * Update password request
     * @todo: move to user store
     * @param context
     * @param newPassword
     * @param enc
     * @returns {Promise<any>}
     */
    async [ACTIONS.UPDATE_PASSWORD](context, { newPassword, enc }) {
      const response = await api.updatePassword(newPassword, enc);
      return response.data;
    },
  },
};
